package org.matthewo.hooks

import react.RefCallback
import react.useRefCallback
import react.useState

fun <T : Any> useStatefulRef(
    vararg dependencies: Any?,
): Pair<T?, RefCallback<T>> {
    var state by useState<T>()
    val callback = useRefCallback<T>(*dependencies) {
        state = it
    }
    return state to callback
}
